module.exports = __webpack_public_path__ + "static/media/salon.43319675.svg";